import React, { useRef, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import { __ } from "services/Translator";
import Imgix from "react-imgix";
import api from "services/api";

export default function LandingBanner(props) {
  // LandingBanner

  const bannerSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
    autoplay: false,
    autoplaySpeed: 5000,
    arrows: false,
    customPaging: function (i) {
      return (
        <a className={props.landingType}>
          <div className="round">
            <i class="fas fa-circle"></i>
          </div>
          <div className="line"></div>
        </a>
      );
    },
    dotsClass: "slick-dots banner_right",
  };

  const bannerRef = useRef();

  const [animationStarts, setAnimationStarts] = useState(false);
  useEffect(() => {
    setAnimationStarts(true);
    setTimeout(function () {
      setAnimationStarts(false);
    }, 100);
  }, [props.landingType]);
  function scrollToContent() {
    const target = document.getElementById("scrollTarget");
    target.scrollIntoView({ behavior: "smooth" });
  }
  return (
    <section className={"banner homeBanner "}>
      <div className="banner_left">
        <div className="card_icons">
          <div className="item">
            <img
              src={
                require("assets/images/new-landing/icons/card-1.png").default
              }
              alt="Card-Icon"
            />
          </div>
          <div className="item">
            <img
              src={
                require("assets/images/new-landing/icons/card-2.png").default
              }
              alt="Card-Icon"
            />
          </div>
          <div className="item">
            <img
              src={
                require("assets/images/new-landing/icons/card-3.png").default
              }
              alt="Card-Icon"
            />
          </div>
          <div className="item">
            <img
              src={
                require("assets/images/new-landing/icons/card-4.png").default
              }
              alt="Card-Icon"
            />
          </div>
        </div>
        <div
          onClick={() => {
            scrollToContent();
          }}
          className="arrow_icon"
        >
          <i class="far fa-angle-down"></i>
        </div>
      </div>
      <div className="banner_content">
        <Slider ref={bannerRef} {...bannerSettings}>
          <div className="slick_item">
            <div className="single_banner">
              <div className="banner_middle">
                <div className="title italic">
                  {__("WELCOME TO JOKER CASINO")}
                </div>
                <div className="headline">
                  {__("Elite world")} <br />
                  {__("Casino")}
                </div>
                <div className="paragraph small_screen_white padding_top_15 padding_bottom_15">
                  {__(
                    "Register and start playing right away with 20 Free Spins on a selection of awesome, thrilling games. You decide which game you want to play the free spins on."
                  )}
                </div>

                <>
                  <div className="banner_count padding_top_bottom_30">
                    {props.totals && (
                      <>
                        <div className="count_area">
                          <div className="single_count">
                            <div className="number">
                              {props.totals.totalPlayers}+
                            </div>
                            <div className="paragraph">
                              {__("Players Online")}
                            </div>
                          </div>
                          <div className="single_count">
                            <div className="number">
                              {props.totals.totalGames}+
                            </div>
                            <div className="paragraph">{__("Games")}</div>
                          </div>
                        </div>
                      </>
                    )}{" "}
                    {props.isAuthenticated ? (
                      <Link
                        to="/games/slots"
                        className={"angle_btn " + props.landingType}
                      >
                        {__("Play Now")}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="25"
                          height="25"
                          fill="red"
                          class="bi bi-arrow-right"
                          viewBox="0 0 16 16"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                          />
                        </svg>
                      </Link>
                    ) : (
                      <Link
                        onClick={() => {
                          props.setModalSignUpPropsData(true);
                        }}
                        className={"angle_btn " + props.landingType}
                      >
                        {__("Sign Up Now")}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="25"
                          height="25"
                          fill="red"
                          class="bi bi-arrow-right"
                          viewBox="0 0 16 16"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                          />
                        </svg>
                      </Link>
                    )}
                  </div>
                </>
              </div>
              <div className={"banner_img " + props.landingType}>
                {props.isMobileDevice ? (
                  <img
                    alt="game image"
                    style={{ marginTop: "-80px" }}
                    src={
                      require("assets/images/banners/roulette-mobile.png")
                        .default
                    }
                  />
                ) : (
                  <img
                    alt="game image"
                    src="https://chimpbytes.imgix.net/home-banner-bg.png?&dpr=1&format=auto&auto=format&q=50&w=960&h=858&max-age=2629056"
                  />
                )}
              </div>
            </div>
          </div>
          <div className="slick_item">
            <div className="single_banner">
              <div className="banner_middle">
                <div className="title italic">
                  {__("WELCOME TO JOKER CASINO")}
                </div>
                <div className="headline">
                  {__("Elite world")}
                  <br />
                  {__("Casino")}
                </div>
                <div className="paragraph small_screen_white padding_top_15 padding_bottom_15">
                  {__(
                    "Register and start playing right away with 20 Free Spins on a selection of awesome, thrilling games. You decide which game you want to play the free spins on."
                  )}
                </div>

                <>
                  <div className="banner_count padding_top_bottom_30">
                    {props.totals && (
                      <>
                        <div className="count_area">
                          <div className="single_count">
                            <div className="number">
                              {props.totals.totalPlayers}+
                            </div>
                            <div className="paragraph">
                              {__("Players Online")}
                            </div>
                          </div>
                          <div className="single_count">
                            <div className="number">
                              {props.totals.totalGames}+
                            </div>
                            <div className="paragraph">{__("Games")}</div>
                          </div>
                        </div>
                      </>
                    )}{" "}
                    {props.isAuthenticated ? (
                      <Link
                        to="/games/slots"
                        className={"angle_btn " + props.landingType}
                      >
                        {__("Play Now")}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="25"
                          height="25"
                          fill="red"
                          class="bi bi-arrow-right"
                          viewBox="0 0 16 16"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                          />
                        </svg>
                      </Link>
                    ) : (
                      <Link
                        onClick={() => {
                          props.setModalSignUpPropsData(true);
                        }}
                        className={"angle_btn " + props.landingType}
                      >
                        {__("Sign Up Now")}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="25"
                          height="25"
                          fill="red"
                          class="bi bi-arrow-right"
                          viewBox="0 0 16 16"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                          />
                        </svg>
                      </Link>
                    )}
                  </div>
                </>
              </div>
              <div className={"banner_img " + props.landingType}>
                {props.isMobileDevice ? (
                  <img
                    alt="game image"
                    style={{ marginTop: "-80px" }}
                    src={
                      require("assets/images/banners/all-sports-mobile.png")
                        .default
                    }
                  />
                ) : (
                  <img
                    alt="game image"
                    src="https://chimpbytes.imgix.net/sport-banner-bg.png?&dpr=1&format=auto&auto=format&q=50&w=960&h=858&max-age=2629056"
                  />
                )}
              </div>
            </div>
          </div>
          <div className="slick_item">
            <div className="single_banner">
              <div className="banner_middle">
                <div className="title italic">
                  {__("WELCOME TO JOKER CASINO")}
                </div>
                <div className="headline">
                  {__("Elite world")}
                  <br />
                  {__("Casino")}
                </div>
                <div className="paragraph small_screen_white padding_top_15 padding_bottom_15">
                  {__(
                    "Register and start playing right away with 20 Free Spins on a selection of awesome, thrilling games. You decide which game you want to play the free spins on."
                  )}
                </div>

                <>
                  <div className="banner_count padding_top_bottom_30">
                    {props.totals && (
                      <>
                        <div className="count_area">
                          <div className="single_count">
                            <div className="number">
                              {props.totals.totalPlayers}+
                            </div>
                            <div className="paragraph">
                              {__("Players Online")}
                            </div>
                          </div>
                          <div className="single_count">
                            <div className="number">
                              {props.totals.totalGames}+
                            </div>
                            <div className="paragraph">{__("Games")}</div>
                          </div>
                        </div>
                      </>
                    )}
                    {props.isAuthenticated ? (
                      <Link
                        to="/games/slots"
                        className={"angle_btn " + props.landingType}
                      >
                        {__("Play Now")}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="25"
                          height="25"
                          fill="red"
                          class="bi bi-arrow-right"
                          viewBox="0 0 16 16"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                          />
                        </svg>
                      </Link>
                    ) : (
                      <Link
                        onClick={() => {
                          props.setModalSignUpPropsData(true);
                        }}
                        className={"angle_btn " + props.landingType}
                      >
                        {__("Sign Up Now")}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="25"
                          height="25"
                          fill="red"
                          class="bi bi-arrow-right"
                          viewBox="0 0 16 16"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                          />
                        </svg>
                      </Link>
                    )}
                  </div>
                </>
              </div>
              <div className={"banner_img " + props.landingType}>
                {props.isMobileDevice ? (
                  <img
                    alt="game image"
                    src={
                      require("assets/images/banners/poker-mobile.png").default
                    }
                  />
                ) : (
                  <img
                    alt="game image"
                    src="https://chimpbytes.imgix.net/poker-banner-bg.png?&dpr=1&format=auto&auto=format&q=50&w=960&h=858&max-age=2629056"
                  />
                )}
              </div>
            </div>
          </div>
          <div className="slick_item">
            <div className="single_banner">
              <div className="banner_middle">
                <div className="title italic">
                  {__("WELCOME TO JOKER CASINO")}
                </div>
                <div className="headline">
                  {__("Elite world")} <br /> {__("Casino")}
                </div>
                <div className="paragraph small_screen_white padding_top_15 padding_bottom_15">
                  {__(
                    "Register and start playing right away with 20 Free Spins on a selection of awesome, thrilling games. You decide which game you want to play the free spins on."
                  )}
                </div>

                <>
                  <div className="banner_count padding_top_bottom_30">
                    {props.totals && (
                      <>
                        <div className="count_area">
                          <div className="single_count">
                            <div className="number">
                              {props.totals.totalPlayers}+
                            </div>
                            <div className="paragraph">
                              {__("Players Online")}
                            </div>
                          </div>
                          <div className="single_count">
                            <div className="number">
                              {props.totals.totalGames}+
                            </div>
                            <div className="paragraph">{__("Games")}</div>
                          </div>
                        </div>
                      </>
                    )}
                    {props.isAuthenticated ? (
                      <Link
                        to="/games/slots"
                        className={"angle_btn " + props.landingType}
                      >
                        {__("Play Now")}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="25"
                          height="25"
                          fill="red"
                          class="bi bi-arrow-right"
                          viewBox="0 0 16 16"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                          />
                        </svg>
                      </Link>
                    ) : (
                      <Link
                        onClick={() => {
                          props.setModalSignUpPropsData(true);
                        }}
                        className={"angle_btn " + props.landingType}
                      >
                        {__("Sign Up Now")}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="25"
                          height="25"
                          fill="red"
                          class="bi bi-arrow-right"
                          viewBox="0 0 16 16"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                          />
                        </svg>
                      </Link>
                    )}
                  </div>
                </>
              </div>
              <div className={"banner_img " + props.landingType}>
                {props.isMobileDevice ? (
                  <img
                    alt="game image"
                    style={{ marginTop: "-50px" }}
                    src={
                      require("assets/images/banners/bingo-mobile.png").default
                    }
                  />
                ) : (
                  <img
                    alt="game image"
                    src="https://chimpbytes.imgix.net/orange-banner-bg.png?&dpr=1&format=auto&auto=format&q=50&w=960&h=858&max-age=2629056"
                  />
                )}
              </div>
            </div>
          </div>
          <div className="slick_item">
            <div className="single_banner">
              <div className="banner_middle">
                {/* <div className="title italic">
                  {__("WELCOME TO JOKER CASINO")}
                </div> */}
                <div className="headline">
                  {__("Joker openning")} <br /> {__("Tournament")}
                </div>
                <div className="quotedHeadline">{__("No Any Slot Game")}</div>
                <div className="paragraph small_screen_white padding_top_15 padding_bottom_15">
                  {__(
                    "Register and start playing right away with 20 Free Spins on a selection of awesome, thrilling games. You decide which game you want to play the free spins on."
                  )}
                </div>

                <>
                  <div className="banner_count padding_top_bottom_30">
                    {props.totals && (
                      <>
                        <div className="count_area">
                          <div className="single_count">
                            <div className="number">
                              {props.totals.totalPlayers}+
                            </div>
                            <div className="paragraph">
                              {__("Players Online")}
                            </div>
                          </div>
                          <div className="single_count">
                            <div className="number">
                              {props.totals.totalGames}+
                            </div>
                            <div className="paragraph">{__("Games")}</div>
                          </div>
                        </div>
                      </>
                    )}
                    {props.isAuthenticated ? (
                      <Link
                        to="/games/slots"
                        className={"angle_btn " + props.landingType}
                      >
                        {__("Play Now")}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="25"
                          height="25"
                          fill="red"
                          class="bi bi-arrow-right"
                          viewBox="0 0 16 16"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                          />
                        </svg>
                      </Link>
                    ) : (
                      <Link
                        onClick={() => {
                          props.setModalSignUpPropsData(true);
                        }}
                        className={"angle_btn " + props.landingType}
                      >
                        {__("Sign Up Now")}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="25"
                          height="25"
                          fill="red"
                          class="bi bi-arrow-right"
                          viewBox="0 0 16 16"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                          />
                        </svg>
                      </Link>
                    )}
                  </div>
                </>
              </div>
              <div className={"banner_img " + props.landingType}>
                {props.isMobileDevice ? (
                  <img
                    alt="game image"
                    style={{ marginTop: "-60px" }}
                    src={
                      require("assets/images/banners/races-banner-mobile.png")
                        .default
                    }
                  />
                ) : (
                  <img
                    alt="game image"
                    src={
                      require("assets/images/banners/racing-banner.png").default
                    }
                  />
                )}
              </div>
            </div>
          </div>
          <div className="slick_item">
            <div className="single_banner">
              <div className="banner_middle">
                {/* <div className="title italic">
                  {__("WELCOME TO JOKER CASINO")}
                </div> */}
                <div className="headline">
                  {__("Rewards")} <br /> {__("Ranks Program")}
                </div>
                <div className="quotedHeadline">{__("No Any Slot Game")}</div>
                <div className="paragraph small_screen_white padding_top_15 padding_bottom_15">
                  {__(
                    "Register and start playing right away with 20 Free Spins on a selection of awesome, thrilling games. You decide which game you want to play the free spins on."
                  )}
                </div>

                <>
                  <div className="banner_count padding_top_bottom_30">
                    {props.totals && (
                      <>
                        <div className="count_area">
                          <div className="single_count">
                            <div className="number">
                              {props.totals.totalPlayers}+
                            </div>
                            <div className="paragraph">
                              {__("Players Online")}
                            </div>
                          </div>
                          <div className="single_count">
                            <div className="number">
                              {props.totals.totalGames}+
                            </div>
                            <div className="paragraph">{__("Games")}</div>
                          </div>
                        </div>
                      </>
                    )}
                    {props.isAuthenticated ? (
                      <Link
                        to="/games/slots"
                        className={"angle_btn " + props.landingType}
                      >
                        {__("Play Now")}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="25"
                          height="25"
                          fill="red"
                          class="bi bi-arrow-right"
                          viewBox="0 0 16 16"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                          />
                        </svg>
                      </Link>
                    ) : (
                      <Link
                        onClick={() => {
                          props.setModalSignUpPropsData(true);
                        }}
                        className={"angle_btn " + props.landingType}
                      >
                        {__("Sign Up Now")}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="25"
                          height="25"
                          fill="red"
                          class="bi bi-arrow-right"
                          viewBox="0 0 16 16"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                          />
                        </svg>
                      </Link>
                    )}
                  </div>
                </>
              </div>
              <div className={"banner_img " + props.landingType}>
                {props.isMobileDevice ? (
                  <img
                    alt="game image"
                    style={{ marginTop: "-170px" }}
                    src={
                      require("assets/images/banners/rewards-comp-mobile.png")
                        .default
                    }
                  />
                ) : (
                  <img
                    alt="game image"
                    src={
                      require("assets/images/banners/rewards-comp.png").default
                    }
                  />
                )}
              </div>
            </div>
          </div>
        </Slider>

        {!props.isMobileDeviceByViewPort && (
          <div className="banner_features_list">
            <div className="single_item">{__("01. Premium Games")}</div>
            <div className="single_item">{__("02. Top Bonuses")}</div>
            <div className="single_item">{__("03. Fast Payouts")}</div>
            <div className="single_item">{__("04. Big Jackpots")}</div>
            <div className="single_item">{__("05. 24/7 Support")}</div>
          </div>
        )}
      </div>
    </section>
  );
}
